import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../Styles/Footer.module.css';

const Header = ({ formInfo }) => {
  const navigate = useNavigate();

  return (
  <>
    <div className={styles.footer}>
        <div className={styles.footerInner}>
            <div className={styles.verticalBlock}>
                <img className={styles.logo} src='/img/logo/logo-taksahouse2.png' alt='TaksaHouse' />
                <a>Адрес расположения: {formInfo?.address}</a>
                <a>{formInfo?.phone_number}</a>
                {formInfo?.phone_number_additional && <a>{formInfo?.phone_number_additional}</a>}
            </div>
            <div className={styles.spanBtns}>
            <button className={styles.button} onClick={() => {navigate('/auth/login');}}>Вход для персонала</button>
            </div>
        </div>
    </div>
  </>
  )
}

export default Header;